import { PhotoIcon } from '@heroicons/react/24/outline';

const EmptyImage = () => {
  return <PhotoIcon className="w-6 h-6" />;
};

export default EmptyImage;
